export enum ModalType {
  Settings = 'Settings',
  Bonuses = 'Bonuses',
  UserEnergy = 'UserEnergy',
  ItemLoading = 'ItemLoading',
  ItemInfo = 'ItemInfo',
  ItemCard = 'ItemCard',
  ItemDisabled = 'ItemDisabled',
  AllItemsOpened = 'AllItemsOpened',
  ProjectFinished = 'ProjectFinished',
  ProjectFinishesSoon = 'ProjectFinishesSoon',
}

export type ModalState = {
  currentModal: ModalType | null;
};
